import React from 'react';

type SectionMarkerBlockProps = {
  content: {
    title: string;
    color?: string;
    description?: string;
  };
  onChange: (content: { title: string; color?: string; description?: string }) => void;
  previewMode?: boolean;
  exportHidden?: boolean;
};

/**
 * SectionMarkerBlock — invisible in the canvas and in all exports.
 * The section name is edited exclusively via the Properties panel.
 * The parent Rnd wrapper still provides selection/drag handles.
 */
export const SectionMarkerBlock: React.FC<SectionMarkerBlockProps> = ({
  exportHidden = false,
}) => {
  // Always invisible during export/preview
  if (exportHidden) return null;

  // Render nothing — the block is selected/dragged via the parent Rnd container
  return null;
};
